import { render, staticRenderFns } from "./speaker.vue?vue&type=template&id=7b68352d&scoped=true&"
import script from "./speaker.vue?vue&type=script&lang=js&"
export * from "./speaker.vue?vue&type=script&lang=js&"
import style0 from "./speaker.vue?vue&type=style&index=0&id=7b68352d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b68352d",
  null
  
)

export default component.exports